export const rsvp = {
  addToCalendar: {
    description: "So you don't miss it!",
    heading: "Add this event to your calendar",
    cta: "Add to Calendar",
  },
  authenticate: {
    getStartedCta: "Sign Up",
    modal: {
      heading:
        "We'd love to have you attend this event! Please sign in or create an account so we know who you are...",
      subheading:
        "BTW, we foster an intimate and safe space at our events by keeping them members-only. To join our community, start by creating an account and telling us about your journey.",
      createAccountCta: "Create an account",
      signInCta: "Log in",
      tos: "By creating an account you agree to our Terms of Service and Privacy Policy.",
    },
    viewMoreCta: "View More",
  },
  plus: {
    modal: {
      heading: "Unlock our community events with a Premium membership!",
      subheading:
        "Our events are accessible to Premium members only. Community is the reason we believe Premium members are three times more likely to become pregnant. We'd love to have you join us! All you have to do is upgrade...",
      cta: "Upgrade to Premium",
    },
    upgradeToAttendCta: "Sign Up",
    upgradeTextCta: "Upgrade your membership",
    upgradeText: "to attend",
    viewMoreCta: "View More",
  },
  register: {
    cta: "Sign Up",
    confirmation: {
      heading: "You're registered!",
      subheading:
        "We can't wait to see you there. When it's time, find a quiet spot, turn your camera on, and settle in with your favorite drink and snack.<br>:date: Don't forget to add the event to your calendar below :arrow_down:",
      done: "Done",
    },
    apple: {
      alt: "Apple Calendar",
      description: "Add to Apple Calendar",
    },
    google: {
      alt: "Google Calendar",
      description: "Add to Google Calendar",
    },
    outlook: {
      alt: "Outlook Calendar",
      description: "Add to Outlook Calendar",
    },
  },
  unregister: {
    rsvpStatus: "You're Registered!",
    description: "Can't make it anymore?",
    cta: "Unregister.",
    confirmation: {
      cancel: "Nevermind",
      heading: "Are you sure? Our events fill-up quickly!",
      unregister: "Unregister",
    },
    feedback: {
      heading: "We've taken you off this event list",
      prompt:
        "If you have a moment, we'd love to know why you can no longer make it. That helps us make the best events for you in future!",
      cta: "Submit",
      otherPlaceholder: "Please specify",
    },
  },
  upcomingEvents: {
    links: {
      addToCalendar: "+ Add to Calendar",
      joinEvent: "Join event",
      viewEventDetails: "View event details",
    },
  },
  upsellSection: {
    authenticate: {
      heading: "Unlock access to our community events",
      description:
        "With a Premium membership, you get access to community groups curated for you, live events, chat groups, and 1:1s with our nurse and coach team. The magic of our community is why we believe Premium members are three times more likely to get pregnant.",
      cta: "Get Started",
    },
    upgrade: {
      heading: "Unlock Access to our community events",
      description:
        "With a Premium membership, you get access to community groups curated for you, live events, chat groups, and 1:1s with our nurse and coach team. The magic of our community is why we believe Premium members are three times more likely to get pregnant.",
      cta: "Upgrade my membership to Premium",
      ctaWithBreak: "Upgrade my membership <br>to Premium",
    },
  },
};
